import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../../shared/global-data';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { QuestionnaireService } from '../../shared/services/questionnare.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from "../../../app/shared/services/google-analytics-service.service";
import * as CryptoJS from 'crypto-js';
import * as Enums from '../../shared/enums';
import { SecurityService } from 'src/app/shared/services/security.service';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	score: string = "";
	scoreRate: string = "";
	labelScore: string = "";
	showElearning: boolean = true;
	isSars: boolean = false;
	owlOptions: OwlOptions = {
		items: 1,
		dots: true,
		nav: false
	};
	hdData: any = [];
	queId: String = '1161';
	userData:any;
    isLoading:boolean = false;
	isMomWellness: boolean = false;
    IsNedBank:boolean=false;
	qdata:string;
	isWellnessView: boolean = false;
	isSiteMomWellness = localStorage.getItem('loadMomWellnessStylesheet');

	constructor(
		   private router: Router, 
		   private globalData: GlobalDataService, 
		   private queServ: QuestionnaireService, 
		   private googleAnalyticsService: GoogleAnalyticsService,
		   private service:SecurityService,
		   private lsService: StorageMap) {
		this.removeHDPostsIfOld();
		// this.onBarcodeScanned();
		let getHDPostsLS = localStorage.getItem('hdPosts');
		this.lsService.get('profileData').subscribe((lsData: any) => {
			if(typeof lsData !== 'undefined'){
				this.userData = lsData;
				this.isMomWellness = lsData.loadMomWellnessStylesheet;
				this.IsNedBank = lsData.isNedBank;
			}
		});
	
		if (getHDPostsLS != null) {
			this.filterHDPostData(JSON.parse(getHDPostsLS));
		}
		else{
			// get HD posts
			this.getHDPosts().then((data) => {
				localStorage.setItem('hdPosts', JSON.stringify(data));
				this.filterHDPostData(data);
			});
	  	}
	}
	generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
    }
	onBarcodeScanned() {
		// Generate the Perigon URL for 'mental' type
		let guid = this.generateGUID();
		let url = Enums.PERIGON_SURVEY_URL + Enums.PERIGON_SURVEY.MENTAL;
		this.qdata = url;
		// Optionally, you can use the scanned barcode value if needed
		// For example: this.qdata = barcode;
	  }
	ngOnInit() {
		this.removeHDPostsIfOld();

		this.getScore();

		this.elearningCheck();

		$('body').removeClass('logged-out-view');
		this.globalData.changeCurrentViewState('dashboard');

		this.queServ.getQuestionnaire(this.queId).subscribe(result => {
			if (result !== undefined) {
				localStorage.setItem('questionnaire', JSON.stringify(result));
			}
		});
	}
	loadView(page) {

		if (page == "e-learning" || page == "survey" || page == "video" || page == "assessment" || page == "wellbeing-hub") {
			this.isWellnessView = false;
			$('body').addClass('mini-menu'); // Add mini dashboard menu
			this.router.navigate([page]);
			if(this.isSiteMomWellness){// Google Analytics Elearning Tags 
				this.elearningdashboardblockMomentumwellness();
			}else{
				this.elearningdashboardblockMHwellness();
			}
		} else {
			this.isWellnessView = true;
			this.globalData.changeCurrentViewState('well-being');
			//$('body').addClass('mini-menu');
			this.router.navigate([page]);
		}
	}

	removeHDPostsIfOld() {
		localStorage.removeItem('hdPosts'); // fallback if malformed
	}
	

	filterHDPostData(data) {
		console.log('Received data:', data); // Log the data to inspect its structure
	  
		if (Array.isArray(data)) {
		  let filteredData = data.slice(0, 3).map(i => {
			let img = i.descriptorDom?.components?.images;
			return {
			  id: i.id,
			  title: i.descriptorDom?.components?.blurbT || 'No Title',
			  description: i.descriptorDom?.components?.descriptionHtml || 'No Description',
			  image: img || 'default-image-url.jpg',
			  link: 'https://www.hellodoctor.co.za/blog?title='+ i.descriptorDom?.components?.blurbT,
			};
		  });
		  this.hdData = filteredData;
		} else {
		  console.error('Expected an array, but received:', data);
		}
	  }
	  
	  
	  
	async getHDPosts() {
		let response = await fetch(`https://healthhub.momentumhealth.co.za/hub/api/crafter/v1/children?crafterSite=mhs-well-blog&crafterUrl=/site/items/blogs`);
		let data = await response.json();
		return data;
	}

	openHDPost(link: string) {
		const newWindow = window.open(link, '_blank');
		if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
		  alert('Popup blocked! Please allow popups for this site.');
		}
	  }

	getScore() {
		var id = CryptoJS.AES.decrypt(localStorage.getItem("userIdNumber"), this.globalData.secretKey).toString(CryptoJS.enc.Utf8);
		let idnumber = id.toString(CryptoJS.enc.Utf8);
		this.queServ.getScoreQuestionnaire(idnumber).subscribe(result => {
			if (result !== "undefined") {
				if(result?.errorCode=="401")
				{
					this.score = "0";
					this.scoreRate = "No Rating"
					this.labelScore = "new";
				}
				else
				{
				this.score = result[0].score


				if (this.score <= "20") {
					this.scoreRate = "is good";
					this.labelScore = "green";
				} else if (this.score <= "45") {
					this.scoreRate = "could be better";
					this.labelScore = "old";
				} else if (this.score <= "100"){
					this.scoreRate = "is at risk";
					this.labelScore = "new";
				  }else{
					  this.score = "99";
					  this.scoreRate = "is at risk";
					this.labelScore = "new";
				  }
				}

			} else {
				this.score = "0";
				this.scoreRate = "No Rating"
				this.labelScore = "new";
			}

		});
	}

	elearningCheck() {
		$('body').addClass('mini-menu'); // Add mini dashboard menu

		let str = localStorage.getItem('ParentCode');
		let ParentCode = str.replace(/\s/g, '');

		if (ParentCode == "60088") { //SARS -South African Revenue Service
			this.showElearning = true;
			this.isSars = true;
		} else {
			this.showElearning = true;
			this.isSars = false;
		}
	}

	//Google analytics for MH wellness
	elearningdashboardblockMHwellness() {
		this.googleAnalyticsService.pushDirectEvent( 'Elearning Dashboard Click',  'Member MHWwellness ELearning Dashboard - Post Login',  'Member MHWwellness Elearning Dashboard - Post Login' );
		this.googleAnalyticsService.pushDirectEvent( 'Elearning Dashboard Click',  'Member MHWwellness ELearning Dashboard - Post Login',  'Member MHWwellness Elearning Dashboard - Post Login' );
	}
	//Google analytics for Momentum wellnes 
	elearningdashboardblockMomentumwellness() {
		this.googleAnalyticsService.pushDirectEvent( 'Elearning Dashboard Click',  'Member MomentumWellness ELearning Dashboard - Post Login',  'Member MomentumWellness Elearning Dashboard - Post Login' );
		this.googleAnalyticsService.pushDirectEvent( 'Elearning Dashboard Click',  'Member MomentumWellness ELearning Dashboard - Post Login',  'Member MomentumWellness Elearning Dashboard - Post Login' );
	}

	//Call HLC API
    goToHLCSite()
    {
        // alert("hello");
        let url  = Enums.API_HLC_PATHS;
        let id = Enums.HLC_CLIENT_ID;
        let key = Enums.HLC_CLIENT_SECRET;
        //console.log(url);
        //window.location.href = "https://mmi.myhealth360.co.za";  
        //return;
        let obj={
            "grant_type":"",
            "client_id":id,
            "client_secret":key
        };
        let data = this.userData;
        let payLoad={
            grant_type:"",
            client_id:id,
            client_secret:key,
            uniqueId : data.uniqueId,
            mmiClientId : data.mmiClientId,
            username : data.username,
            firstname : data.firstname,
            surname : data.surname,
            emailAddress : data.emailAddress,
            cellularNumber : data.cellularNumber
        };
        this.isLoading = true;
        //below is new code which is fast.
        this.service.authenticateHLCWithThirdpartyApi(payLoad).subscribe(
            (res)=>{
                if(res.tokenStatus == "Authenticated" && res.statusCode == "success"){
                    localStorage.setItem("HLCAuth",JSON.stringify(res));
                    //window.location.href = res.redirect;
					window.open(res.redirect, '_self');
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 10000);
                }
				else if(res.statusCode == "BadRequest"){
						this.isLoading = false;
						alert("Something went wrong. Please try again later.");
						//this.showError = true;
						//this.errorMessage = "Something went wrong. Please try again later.";
				}
            },
            (err)=>{
                console.log("error");
                this.isLoading = false;
            }
        )
    }

}